const permissions = [
  {
    id: 1,
    name: "Dashboards",
    children: [
      { id: "1_1", name: "Overview Dashboard", permissions: { isView: false } },
      { id: "1_2", name: "Reviews", permissions: { isView: false } },
      { id: "1_3", name: "Reviews History", permissions: { isView: false } },
    ],
  },
  {
    id: 2,
    name: "Bookings",
    children: [
      { id: "2_1", name: "Orders", permissions: { isView: false } },
      { id: "2_2", name: "Workspace", permissions: { isView: false } },
      { id: "2_3", name: "Meeting Rooms", permissions: { isView: false } },
      { id: "2_4", name: "Workshops", permissions: { isView: false } },
      { id: "2_5", name: "Website Requests", permissions: { isView: false } },
    ],
  },
  {
    id: 3,
    name: "Management",
    children: [
      { id: "3_1", name: "Cities", permissions: { isView: false } },
      { id: "3_2", name: "Amenities", permissions: { isView: false } },
      { id: "3_3", name: "Branches", permissions: { isView: false } },
      { id: "3_4", name: "WS Management", permissions: { isView: false } },
      { id: "3_5", name: "Setting", permissions: { isView: false } },
      { id: "3_6", name: "API Logs", permissions: { isView: false } },
    ],
  },
  {
    id: 4,
    name: "Rewards",
    children: [
      { id: "4_1", name: "Rewards", permissions: { isView: false } },
      { id: "4_2", name: "Coupons", permissions: { isView: false } },
    ],
  },
  {
    id: 5,
    name: "Customers, Users",
    children: [
      { id: "5_1", name: "Customers", permissions: { isView: false } },
      { id: "5_2", name: "Users", permissions: { isView: false } },
    ],
  },
];

function hasPermission(accountType, adminPermissions, permissionId) {
  // If accountType is superadmin, return true
  // TODWORKSPACECHANGE_PERMISSION
  return true;
  if (accountType === "superadmin") {
    return true;
  }

  // Loop through the adminPermissions array to find the permission
  for (const permissionGroup of adminPermissions) {
    for (const child of permissionGroup.children) {
      // Check if the current child has the same permissionId
      if (child.id === permissionId) {
        return child.permissions.isView; // Return the permission value (true/false)
      }
    }
  }

  // If permissionId not found, return false
  return false;
}

function hasMenuPermission(accountType, adminPermissions, mainId) {
  // If accountType is superadmin, return true
  if (accountType === "superadmin") {
    return true;
  }

  // Find the main permission group by id
  const mainPermissionGroup = adminPermissions.find(
    (group) => group.id === mainId
  );

  if (mainPermissionGroup) {
    // Check if any child has isView: true
    return mainPermissionGroup.children.some(
      (child) => child.permissions.isView
    );
  }

  // If no main permission group found, return false
  return false;
}

export { permissions, hasPermission, hasMenuPermission };
